module.exports = __webpack_public_path__ + "img/9788982731921.e6d7c5a6.jpg";